import type { HttpHeaders, HttpStatusCode, ReadonlyHttpHeaders } from '../../types/web/http';
import { MapHttpHeaders } from '../http/headers.ts';

/**
 * RFC 9457 - Problem Details for HTTP APIs
 */
export type ProblemDetail = {
    title?: string;
    status: number;
    detail?: string;
    [key: string]: unknown;
}

export type ErrorResponse = {
    readonly statusCode: HttpStatusCode;
    readonly headers: HttpHeaders;
    readonly body: ProblemDetail;
}

export class ErrorResponseError extends Error implements ErrorResponse {
    readonly #status: HttpStatusCode;
    readonly #headers: ReadonlyHttpHeaders = new MapHttpHeaders();
    readonly body: ProblemDetail;

    constructor(status: HttpStatusCode, body?: ProblemDetail) {
        super();
        this.#status = status;
        this.body = body ?? ErrorResponseError.problemDetailFor(status);
    }

    get statusCode() {
        return this.#status
    }

    set detail(detail: string | undefined) {
        this.body.detail = detail;
    }

    get headers() {
        return this.#headers;
    }

    static problemDetailFor(status: HttpStatusCode, detail?: string): ProblemDetail {
        const problem: ProblemDetail = {
            status: status.value
        };
        if (detail !== undefined) {
            problem.detail = detail;
        }
        return problem;
    }
}
